import React from "react";
import styles from "./Footer.module.css";
import { Link } from "react-router-dom";
import { FaGlobe } from "react-icons/fa";
import { BsSun } from "react-icons/bs";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.left}>
        <p>
          © {new Date().getFullYear()} ImageCompressor . All rights reserved.
        </p>
      </div>
      <div className={styles.right}>
        <Link to="/about" className={styles.link}>
          About Us
        </Link>
        <Link to="/privacy" className={styles.link}>
          Privacy
        </Link>
        <Link to="/terms" className={styles.link}>
          Terms of Use
        </Link>
      </div>
    </footer>
  );
};

export default Footer;
